var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncompleteOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 38,
    viewBox: "0 0 31 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6306 7.95555C7.36289 7.95555 7.95652 7.36191 7.95652 6.62963C7.95652 5.89734 7.36289 5.30371 6.6306 5.30371C5.89832 5.30371 5.30469 5.89734 5.30469 6.62963C5.30469 7.36191 5.89832 7.95555 6.6306 7.95555Z",
    fill: "#DD6A57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6306 18.563C7.36289 18.563 7.95652 17.9693 7.95652 17.237C7.95652 16.5048 7.36289 15.9111 6.6306 15.9111C5.89832 15.9111 5.30469 16.5048 5.30469 17.237C5.30469 17.9693 5.89832 18.563 6.6306 18.563Z",
    fill: "#DD6A57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6306 29.1694C7.36289 29.1694 7.95652 28.5758 7.95652 27.8435C7.95652 27.1112 7.36289 26.5176 6.6306 26.5176C5.89832 26.5176 5.30469 27.1112 5.30469 27.8435C5.30469 28.5758 5.89832 29.1694 6.6306 29.1694Z",
    fill: "#DD6A57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8665 0H2.65183C1.94852 0 1.27402 0.279389 0.776704 0.776704C0.279389 1.27402 0 1.94852 0 2.65183V31.822C0 32.5253 0.279389 33.1998 0.776704 33.6971C1.27402 34.1945 1.94852 34.4738 2.65183 34.4738H15.911V31.822H2.65183V23.8665H26.5183V2.65183C26.5183 1.94852 26.239 1.27402 25.7416 0.776704C25.2443 0.279389 24.5698 0 23.8665 0ZM23.8665 21.2147H2.65183V13.2592H23.8665V21.2147ZM23.8665 10.6073H2.65183V2.65183H23.8665V10.6073Z",
    fill: "#DD6A57"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.498 28.3947L28.6231 26.5186L25.1943 29.9487L21.7655 26.5186L19.8906 28.3947L23.3194 31.8222L19.8906 35.251L21.7655 37.1259L25.1943 33.6971L28.6231 37.1259L30.498 35.251L27.0691 31.8222L30.498 28.3947Z",
    fill: "#DD6A57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteOrders);
export default __webpack_public_path__ + "static/media/incompleteOrders.1d82bf3910b962a678f352b54e5b1c87.svg";
export { ForwardRef as ReactComponent };